<div class="video-upload-progress">
  <mat-progress-spinner
    mode="determinate"
    [value]="output.file.progress.data.percentage"
    diameter="40"
  ></mat-progress-spinner>
  <div class="encoding-message">{{ output.file.progress.data.etaHuman }}</div>
</div>
